jQuery(document).ready(function () {
    jQuery(".nicdark_preloader").delay(1000).fadeOut("slow");
    //START PARALLAX SECTIONS
    jQuery('#nicdark_parallax_booking').parallax("50%", 0.3);
    jQuery('#nicdark_parallaxx_img2').parallax("50%", 0.3);
    jQuery('#nicdark_parallax_2_btns').parallax("50%", 0.3);
    jQuery('#nicdark_parallax_countdown').parallax("50%", 0.3);
    jQuery('#nicdark_parallax_counter').parallax("50%", 0.3);
    //END PARALLAX SECTIONS

	jQuery('.accomodations_container p.intro').setEqualHeightsPerRow();

});
